import iconConfig from "./iconConfig";

const CONFIG: Record<string, Record<string, any>> = {
  endPoints: {
    auth0: import.meta.env.VITE_AUTH0_COMPLETE_URL || "http://localhost:5173",
    userService: import.meta.env.VITE_USER_URL || "http://localhost:8080/user",
    adminService:
      import.meta.env.VITE_ADMIN_URL || "http://localhost:8080/admin",
    dataService: import.meta.env.VITE_DATA_URL || "http://localhost:8082/data",
    exportService:
      import.meta.env.VITE_EXPORT_URL || "http://localhost:8084/export",
    assistant:
      import.meta.env.VITE_ASSISTANT_URL || "http://localhost:8080/assistant",
    legacyUi:
      import.meta.env.VITE_LEGACY_UI_URL ||
      "http://localhost:5174/legacy/clients",
  },
  auth: {
    auth0Enabled: import.meta.env.VITE_AUTH0_ENABLED === "true",
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI,
  },
  cdn: {
    baseUrl:
      import.meta.env.VITE_CDN_BASE_URL || "https://assets.theharrispoll.com",
    icons: iconConfig,
  },
  statSig: {
    statSigSDKKey:
      import.meta.env.VITE_STATSIG_SDK_KEY 
  },
  segments: {
    maxAllowedSegments: import.meta.env.VITE_MAX_ALLOWED_SEGMENTS || 200,
    maxAllowedActiveSegments: Number(import.meta.env.VITE_MAX_ALLOWED_ACTIVE_SEGMENTS) || 20
  },
  export: {
    ablyNameSpace:
      import.meta.env.VITE_ABLY_CHANNEL_PRIVATE_NAMESPACE ||
      "hpoll-quest-socket-private",
  },
  sentry: {
    isSentryEnabled: import.meta.env.VITE_SENTRY_ENABLED,
    sentryDsn: import.meta.env.VITE_SENTRY_DSN,
    sentryEnvironment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    sentrySampleRate: import.meta.env.VITE_SENTRY_SAMPLE_RATE,
    sentryReplaysSsRate: import.meta.env.VITE_SENTRY_REPLAYS_SS_RATE,
    sentryReplaysErrorSsRate: import.meta.env.VITE_SENTRY_REPLAYS_ERROR_SS_RATE,
  },
  pendo: {
    isPendoEnabled: import.meta.env.VITE_PENDO_ENABLED,
    pendoEnvironment: import.meta.env.VITE_PENDO_ENVIRONMENT,
  },
  env: import.meta.env.VITE_ENV,
};

export default CONFIG;
